<template>
<div>

	<div id="item" class="uk-container-expand productsScreen">
		<appNav></appNav>
	</div>

	<div class="uk-container">
		
		<div class="uk-h3">{{ ms }}</div>
		<hr class="uk-divider-icon">

		<div class="CardFirstProducts uk-child-width-1-5@l uk-child-width-1-4@m uk-child-width-1-3@s uk-child-width-1-2 uk-grid-small" uk-grid	>
    <div v-for="(bread, inx) in productsPage" :key="inx">
        <div class="uk-card uk-card-hover uk-card-default">
					<router-link :to="'/product/' + bread.id" class="uk-link-reset">
            <div class="uk-card-media-top">
                <img :src="bread.picSrc" alt="">
            </div>
            <div class="uk-card-body uk-card-small">
                <p>{{ bread.name }}</p>
								<div class=" uk-visible@s uk-label">{{ bread.sort }}</div>
            </div>
					</router-link>
        </div>
				</div>
		</div>

		<button  class="uk-margin uk-button uk-button-text" href="#item" uk-scroll> <i class="mdi mdi-chevron-up"></i>Наверх</button>
		<br>
		<br>

	</div>
	</div>
</template>

<script>
import appNav from '@/components/Nav'

export default {
	data () {
		return {
			ms: 'Продукция'
		}
	},
	computed: {
   productsPage (){
			return this.$store.getters.productsPage
		}
	},
	created() {
			// window.scrollTo(0, 0);
		},
	components: {
		appNav
	}
}
</script>


<style>
.productsScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.productsScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}
</style>